import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import App from "./App";
import "./index.css";

// A deployment can replace content-hashed chunks while a tab is still running
// the previous app shell. Reload once when a lazy import hits a removed chunk,
// so the browser gets the current HTML and its matching asset manifest.
const staleChunkReloadKey = "cde:stale-chunk-reload";
window.addEventListener("vite:preloadError", (event) => {
  try {
    if (window.sessionStorage.getItem(staleChunkReloadKey) === "1") return;
    window.sessionStorage.setItem(staleChunkReloadKey, "1");
    event.preventDefault();
    window.location.reload();
  } catch {
    // Leave Vite's normal error handling in place when storage is unavailable.
  }
});
window.addEventListener("load", () => window.sessionStorage.removeItem(staleChunkReloadKey), {
  once: true,
});

const queryClient = new QueryClient({
  defaultOptions: {
    queries: { retry: 1, refetchOnWindowFocus: false },
    mutations: { retry: 0 },
  },
});

// Earlier versions kept a copy of all cards in IndexedDB; card data now comes
// from the local backend, so drop that store once.
if (typeof indexedDB !== "undefined") {
  indexedDB.deleteDatabase("cde-card-cache");
}

const root = document.getElementById("root");
if (!root) {
  throw new Error("Missing #root element");
}

createRoot(root).render(
  <StrictMode>
    <QueryClientProvider client={queryClient}>
      <App />
    </QueryClientProvider>
  </StrictMode>,
);
